import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { BottomNavigation } from "@components/general/bottom_navigation";
import { AppBar } from "@components/general/app_bar";

export const BaseLayout: ComponentProps = ({ children }) => {
  const { appBar, bottomNavigation } = useThemeStore((state) => state);
  return (
    <div className="tw-h-screen">
      <div id="page" className="tw-min-h-screen">
        {appBar.show && <AppBar />}
        <div className={`page-content tw-relative tw-z-[1] tw-mx-auto tw-min-h-screen tw-bg-background-200 ${appBar.show ? "tw-pt-[50px]" : ""}`}>
          {children}
        </div>
        {bottomNavigation !== "hidden" && (
          <BottomNavigation type={bottomNavigation} />
        )}
      </div>
    </div>
  );
};
